import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
/*import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';*/
//import { AppLayoutComponent } from "./app/layout/app.layout.component";
import {initialLoadingGuard, LoadingPageComponent} from "./app/components/loading-page/loading-page.component";
import { cognitoAuthGuard } from "./app/service/data.service";
import {WriterDashboardComponent} from "./app/components/writer-dashboard/writer-dashboard.component";
import {BetaReaderDashboardComponent} from "./app/components/beta-reader-dashboard/beta-reader-dashboard.component";
import {
    InitialRoleSelectionPageComponent
} from "./app/components/initial-role-selection-page/initial-role-selection-page.component";
import {EditorComponent} from "./app/components/editor/editor.component";
import {NotfoundComponent} from "./app/components/notfound/notfound.component";
import { ProfilePageComponent } from './app/components/profile-page/profile-page.component';

export const appRoutes: Routes = [
    {
        path: '',
        canActivate: [cognitoAuthGuard, initialLoadingGuard],
        component: AppLayout,
        children: [
            { path: '', canActivate: [cognitoAuthGuard], component: LoadingPageComponent },
            { path: 'writer/:project',  canActivate: [cognitoAuthGuard], component: WriterDashboardComponent },
            { path: 'beta_reader/:project',  canActivate: [cognitoAuthGuard], component: BetaReaderDashboardComponent },
            { path: 'writer',  canActivate: [cognitoAuthGuard], component: WriterDashboardComponent },
            { path: 'beta_reader',  canActivate: [cognitoAuthGuard], component: BetaReaderDashboardComponent },
            { path: 'startup',  canActivate: [cognitoAuthGuard], component: InitialRoleSelectionPageComponent },
            //{ path: 'uikit', loadChildren: () => import('./app/components/uikit/uikit.module').then(m => m.UIkitModule) },
            { path: 'utilities',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./app/components/utilities/utilities.module').then(m => m.UtilitiesModule) },
           // { path: 'blocks',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./app/components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
            { path: 'pages',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./app/components/pages/pages.module').then(m => m.PagesModule) },
            { path: 'content/:project/:retUrl',  canActivate: [cognitoAuthGuard], component: EditorComponent },
           // { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes') },
           // { path: 'documentation', component: Documentation },
           // { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') },
           { path: 'profile_page', canActivate: [cognitoAuthGuard], component: ProfilePageComponent}
        ]
    },
    { path: 'auth', canActivate: [initialLoadingGuard], loadChildren: () => import('./app/components/auth/auth.module').then(m => m.AuthModule)},
    { path: 'landing', loadChildren: () => import('./app/components/landing/landing.module').then(m => m.LandingModule) },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'loading', component: LoadingPageComponent },
    { path: '**', redirectTo: '/notfound' },
    /*{ path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }*/
];


/*{
                path: '',
                children: [
                    { path: '', canActivate: [cognitoAuthGuard], component: LoadingPageComponent },
                    //{ path: 'admin',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./components/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule) },
                    { path: 'writer/:project',  canActivate: [cognitoAuthGuard], component: WriterDashboardComponent },
                    { path: 'beta_reader/:project',  canActivate: [cognitoAuthGuard], component: BetaReaderDashboardComponent },
                    { path: 'writer',  canActivate: [cognitoAuthGuard], component: WriterDashboardComponent },
                    { path: 'beta_reader',  canActivate: [cognitoAuthGuard], component: BetaReaderDashboardComponent },
                    { path: 'startup',  canActivate: [cognitoAuthGuard], component: InitialRoleSelectionPageComponent },
                    { path: 'uikit', loadChildren: () => import('./components/uikit/uikit.module').then(m => m.UIkitModule) },
                    { path: 'utilities',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./components/utilities/utilities.module').then(m => m.UtilitiesModule) },
                    { path: 'blocks',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./components/primeblocks/primeblocks.module').then(m => m.PrimeBlocksModule) },
                    { path: 'pages',  canActivate: [cognitoAuthGuard], loadChildren: () => import('./components/pages/pages.module').then(m => m.PagesModule) },
                    { path: 'content/:project/:retUrl',  canActivate: [cognitoAuthGuard], component: EditorComponent }
                ]
            },

            { path: 'auth', canActivate: [initialLoadingGuard], loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule)},
            { path: 'landing', loadChildren: () => import('./components/landing/landing.module').then(m => m.LandingModule) },
            { path: 'notfound', component: NotfoundComponent },
            { path: 'loading', loadChildren: () => import('./components/loading-page/loading-page.module').then(m => m.LoadingPageModule) },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
*/
